export default {
  messages: {
    // other: 'その他',
    // hello: '{word} こんにちは！',
  },
};
